import React, { Component } from 'react';
import Footer from '../../components/footer/Footer.jsx';
import news_png from '../../assets/images/illustrations/newsletter3.png';
import news from '../../assets/images/Autism-webp/Newsletter/04_newsletter_R01@3x.webp';
import newsLow from '../../assets/images/illustrations/newsletter3-low.png';
import mobileNews from '../../assets/images/mobile/04_mobile_newsletter_r_01@3x.png';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import windowSize from 'react-window-size';
import { baseUrl, list_id, mail_token } from '../../common/config';
import md5 from 'md5';
import { withTranslation } from 'react-i18next';
class HomepageLast extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageStatus: 'loading',
            width: this.props.windowWidth,
            height: 0,
            email: '',
            isSent: false,
            emailError: '',
            errorCode: null,
            match: false,
        };
    }
    emails = this.props.emails.data;
    match = false;
    handleChange = (e) => {
        this.setState({
            email: e.target.value,
        });
    };

    handleClick = (e) => {
        e.preventDefault();
        const subEmail = md5(this.state.email);
        // PUT Email to Mailchimp

        fetch(`${baseUrl}/lists/${list_id}/members/${subEmail}`, {
            method: 'Put',
            headers: {
                'Authorization': `Bearer ${mail_token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email_address: this.state.email,
                status: 'subscribed',
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                console.log('Success', res);
            });

        this.setState({
            email: '',
            isSent: false,
        });
    };

    handleImageLoaded = () => {
        this.setState({ imageStatus: 'loaded' });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'failed to load' });
    };

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const { t, i18n } = this.props;
        return (
            <div className='hp hp-last-container'>
                <div className='hp-last'>
                    <div
                        className={`hp-statement ${
                            i18n.language === 'en'
                                ? 'text-left en-hp-statement'
                                : ''
                        }`}
                    >
                        <h2>{t('homepage.connect.title')}</h2>
                        <h5
                            className={`${
                                i18n.language === 'en' ? 'pl-0' : ''
                            }`}
                        >
                            {t('homepage.connect.desc')}
                        </h5>
                        {i18n.language === 'ar' ? (
                            <div className='newsletter-input'>
                                <input
                                    dir='rtl'
                                    type='email'
                                    placeholder={`${t(
                                        'homepage.connect.email'
                                    )}`}
                                    onChange={this.handleChange}
                                    value={this.state.email}
                                />
                                <button
                                    className='register-btn'
                                    onClick={this.handleClick}
                                >
                                    {t('homepage.connect.sub')}
                                </button>
                            </div>
                        ) : (
                            <div className='newsletter-input en-newsletter-input'>
                                <input
                                    dir='ltr'
                                    type='email'
                                    placeholder={`${t(
                                        'homepage.connect.email'
                                    )}`}
                                    onChange={this.handleChange}
                                    value={this.state.email}
                                />
                                <button
                                    className='register-btn'
                                    onClick={this.handleClick}
                                >
                                    {t('homepage.connect.sub')}
                                </button>
                            </div>
                        )}
                    </div>
                    <div className='hp-last-img'>
                        {this.state.width > 700 ? (
                            <>
                                <picture>
                                    <source
                                        srcSet={news_png}
                                        type='image/png'
                                    />
                                    <source srcSet={news} type='image/webp' />
                                    <img
                                        className={`last-img ${
                                            this.state.imageStatus === 'loaded'
                                                ? ''
                                                : 'low-quality aut-low'
                                        } ${
                                            i18n.language === 'en' ? 'flip' : ''
                                        }`}
                                        alt='logo'
                                        src={news}
                                        onLoad={this.handleImageLoaded}
                                        onError={this.handleImageErrored}
                                    />
                                </picture>
                                {this.state.imageStatus === 'loaded' ? (
                                    <></>
                                ) : (
                                    <img
                                        alt='what'
                                        src={newsLow}
                                        className={`last-img ${
                                            i18n.language === 'en' ? 'flip' : ''
                                        }`}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                <img
                                    className={`last-img ${
                                        this.state.imageStatus === 'loaded'
                                            ? ''
                                            : 'low-quality aut-low'
                                    } ${i18n.language === 'en' ? 'flip' : ''}`}
                                    alt='logo'
                                    src={mobileNews}
                                    onLoad={this.handleImageLoaded}
                                    onError={this.handleImageErrored}
                                />
                                {this.state.imageStatus === 'loaded' ? (
                                    <></>
                                ) : (
                                    <img
                                        alt='what'
                                        src={newsLow}
                                        className={`last-img ${
                                            i18n.language === 'en' ? 'flip' : ''
                                        }`}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div>
                {this.state.width > 600 ? (
                    <Footer index={this.props.index} />
                ) : (
                    <Footer index={this.props.index} minimal />
                )}
            </div>
        );
    }
}

export default withTranslation()(windowSize(HomepageLast));
